export type Employee = {
    id: number;
    firstName: string;
    lastName: string;
    middleName?: string;
    email: string;
    phone: string;
    isActive: boolean;
    invitedAt: string;
    activatedAt: string | null;
    role?: string;
    company?: string;
    taxAuthorityDepartment?: string;
};

export type UserStatus = 'ACTIVE' | 'INACTIVE' | 'INVITED';

export const getUserStatus = (employee: Pick<Employee, 'isActive'>): UserStatus =>
    employee.isActive ? 'ACTIVE' : 'INACTIVE';

export type EmployeeWithFullName = Employee & {
    fullName: string;
    actions: React.ReactNode;
    userStatus: UserStatus;
};

export type EmployeesResponse = {
    pageNumber: number;
    pageSize: number;
    pageCount: number;
    pageSort: [];
    totalQuery: number;
    data: Employee[];
};

export type EmployeesRequest = {
    lpId: number;
    size: number;
    number: number;
    sortList?: string[];
    sortDirection?: 'ASC' | 'DESC';
};

export type CreateEmployeeRequest = {
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    middleName?: string;
    phone?: string;
    taxAuthorityDepartment?: number;
};

export type UpdateEmployeeRequest = {
    userId: number;
    body: {
        userName?: string;
        firstName?: string;
        lastName?: string;
        middleName?: string;
        email?: string;
        phone?: string;
        taxAuthorityDepartment?: string;
        active?: boolean;
    };
};

export type ResetPasswordRequest = {
    firstName: string;
    userName: string;
    email: string;
};

export enum Roles {
    DIRECTOR = 'DIRECTOR',
    EMPLOYEE = 'EMPLOYEE',
    OPERATOR = 'OPERATOR',
    CHIEF_INSPECTOR = 'CHIEF_INSPECTOR',
    INSPECTOR = 'INSPECTOR',
}

export type TaxAuthorityDepartment = {
    code: number;
    id: number;
    name: string;
};
